import { render, staticRenderFns } from "./NewsRowCard.vue?vue&type=template&id=b6ed665e&scoped=true&"
import script from "./NewsRowCard.vue?vue&type=script&lang=js&"
export * from "./NewsRowCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsRowCard.vue?vue&type=style&index=0&id=b6ed665e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ed665e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
